<div
  class="job-item"
  [class.abortable]="job().state === JobState.Running && job().abortable"
  [class.interactive]="clickable()"
  [tnTooltip]="job().state === JobState.Failed ? job().error : null"
  [tnTooltipPosition]="'left'"
>
  <div
    class="job-item-body"
    tnTestIdType="row"
    [tnTestId]="['job', job().id]"
    (click)="clickable() && open()"
  >
    <div class="description-line">
      <span class="job-description" tnTestIdType="text" [tnTestId]="['job', job().id, 'description']">
        {{ job().description ? job().description : job().method }}
      </span>
      @if (job().state === JobState.Running) {
        <small class="job-progress-percent" tnTestIdType="text" [tnTestId]="['job', job().id, 'progress']">
          {{ job().progress.percent || 0 | number: '1.2-2' }}%
        </small>
      }
    </div>

    @if (job().state === JobState.Running) {
      <tn-progress-bar
        class="job-progress"
        [value]="job().progress.percent"
        [mode]="job().progress.percent ? 'determinate' : 'indeterminate'"
        [ariaLabel]="'Progress of {job}' | translate: { job: job().description || job().method }"
      ></tn-progress-bar>
    }

    <div>
      @switch (job().state) {
        @case (JobState.Running) {
          @if (job().progress.description) {
            <div class="job-progress-description" tnTestIdType="text" [tnTestId]="['job', job().id, 'progress-description']">
              {{ job().progress.description }}
            </div>
          }
          @if (!job().progress.description) {
            <div class="job-time">
              {{ job().state | jobStateDisplay }}:
              <strong tnTestIdType="text" [tnTestId]="['job', job().id, 'time']">
                {{ job().time_started?.$date ? (job().time_started.$date | formatDateTime) : '–' }}
              </strong>
            </div>
          }
        }
        @case (JobState.Waiting) {
          <div class="job-time">
            {{ job().state | jobStateDisplay }}:
            <strong tnTestIdType="text" [tnTestId]="['job', job().id, 'time']">
              {{ job().time_started?.$date ? (job().time_started.$date | formatDateTime) : '–' }}
            </strong>
          </div>
        }
        @case (JobState.Success) {
           <div class="job-time">
              {{ job().state | jobStateDisplay }}:
              <strong tnTestIdType="text" [tnTestId]="['job', job().id, 'time']">
                {{ job().time_finished?.$date ? (job().time_finished.$date | formatDateTime) : '–' }}
              </strong>
            </div>
        }
        @case (JobState.Failed) {
          <div class="job-time">
            {{ job().state | jobStateDisplay }}:
            <strong tnTestIdType="text" [tnTestId]="['job', job().id, 'time']">
              @let timeFinished = job().time_finished?.$date;
              {{ timeFinished ? (timeFinished | formatDateTime) : '–' }}
            </strong>
          </div>
        }
        @case (JobState.Aborted) {
          <div class="job-time">
            {{ job().state | jobStateDisplay }}:
            <strong tnTestIdType="text" [tnTestId]="['job', job().id, 'time']">
              @let timeFinished = job().time_finished?.$date;
              {{ timeFinished ? (timeFinished | formatDateTime) : '–' }}
            </strong>
          </div>
        }
      }
    </div>

    @if (job().credentials; as credentials) {
      <div>
        <div class="job-credentials">
          {{
          'Created by: {creationSource} ({creationType})' | translate: {
          creationSource: getCredentialsCreationSource(credentials),
          creationType: (credentials.type | mapValue: credentialTypeLabels | translate)
        }
        }}
      </div>
    </div>
  }
</div>

@if (job().state === JobState.Running && job().abortable) {
  <tn-icon-button
    class="job-button-abort"
    name="stop-circle"
    library="mdi"
    [class.job-icon-abort]="true"
    [testId]="['abort', job().description, job().method]"
    [ariaLabel]="'Abort' | translate"
    [tnTooltip]="'Abort' | translate"
    (click)="abort()"
  ></tn-icon-button>
}

@if (job().state === JobState.Waiting) {
  <tn-icon-button
    name="clock-outline"
    library="mdi"
    [class.job-icon-waiting]="true"
    [testId]="['waiting', job().description, job().method]"
    [ariaLabel]="'Waiting' | translate"
    [disabled]="true"
  ></tn-icon-button>
}

@if (job().state === JobState.Failed) {
  <tn-icon-button
    name="close-circle"
    library="mdi"
    tnTooltipPosition="left"
    [class.job-icon-failed]="true"
    [testId]="['failed', job().description, job().method]"
    [ariaLabel]="'Failed' | translate"
    [tnTooltip]="job().error"
    [disabled]="true"
  ></tn-icon-button>
}

@if (job().state === JobState.Success) {
  <tn-icon-button
    name="check-circle"
    library="mdi"
    [class.job-icon-success]="true"
    [testId]="['success', job().description, job().method]"
    [ariaLabel]="'Succeeded' | translate"
    [disabled]="true"
  ></tn-icon-button>
}
</div>
